// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1VfTq","col":"styles_col__3wBCJ","actions":"styles_actions__2HDVQ","conflict":"styles_conflict__1SkAE"};